// Configuration for Orthodontic Table rows, should be similar to the WEB one

export type TableRowConfig = {
  rowIndex: number
  key: string // Unique key for this row (e.g., "sna", "snb")
  title: string
  titleColSpan: number
  columnsPerRow: number // How many input columns in this row
  columnKeys: string[] // Keys for each column (e.g., ["mean", "patient"])
  cellColSpan?: number // If cells span multiple columns
}

export const ORTHODONTIC_TABLE_ROWS: TableRowConfig[] = [
  {
    rowIndex: 1,
    key: 'sna',
    title: 'SNA',
    titleColSpan: 1,
    columnsPerRow: 2,
    columnKeys: ['mean', 'patient'],
  },
  {
    rowIndex: 2,
    key: 'snb',
    title: 'SNB',
    titleColSpan: 1,
    columnsPerRow: 2,
    columnKeys: ['mean', 'patient'],
  },
  {
    rowIndex: 3,
    key: 'sella_nasion_mandibular_plane',
    title: 'Sella-Nasion to Mandibular Plane',
    titleColSpan: 1,
    columnsPerRow: 2,
    columnKeys: ['mean', 'patient'],
  },
  {
    rowIndex: 4,
    key: 'frankfort_horizontal_mandibular_plane',
    title: 'Frankfort Horizontal to Mandibular Plane',
    titleColSpan: 1,
    columnsPerRow: 2,
    columnKeys: ['mean', 'patient'],
  },
]

// Patient's age and sex key
export const PATIENT_AGE_SEX_KEY = 'patient_age_sex'

// Helper to generate cell key: "{rowKey}_{columnKey}"
export const getCellKey = (rowKey: string, columnKey: string): string => `${rowKey}_${columnKey}`

// Helper to get all cell keys for a row
export const getRowCellKeys = (config: TableRowConfig): string[] =>
  config.columnKeys.map((columnKey) => getCellKey(config.key, columnKey))

export const MIN_TABLE_WIDTH = 800 // px
